import React, { useEffect } from 'react';
import { CCard, CCardBody, CSpinner } from '@coreui/react';
import { ConnectAccountOnboarding, useConnectComponents } from '@stripe/react-connect-js';
import { useNavigate } from 'react-router-dom';
import { getDatabase, ref, query, orderByChild, equalTo, update, get } from 'firebase/database';

// Make sure these scripts are in your index.html:
// <script src="https://js.stripe.com/v3/"></script>
// <script async src="https://connect.stripe.com/connect-js/v1"></script>

const Onboarding = ({ authUser, stripeAccountId }) => {
      const navigate = useNavigate();
      const connectComponents = useConnectComponents();
      //const isReady = connectComponents?.ready ?? false;
      const isReady = true;

      useEffect(() => {
            console.log('Onboarding mounted with:', {
                  stripeAccountId,
                  authUser: authUser?.authUser?.email,
                  isReady,
                  hasStripe: !!window.Stripe
            });
      }, [stripeAccountId, authUser, isReady]);

      const handleExit = async () => {
            if (!authUser?.authUser?.email) return;

            try {
                  // Update Firebase when onboarding completes
                  const db = getDatabase();
                  const creatorsRef = ref(db, 'verified_creators');
                  const emailQuery = query(
                        creatorsRef,
                        orderByChild('email'),
                        equalTo(authUser.authUser.email)
                  );

                  const snapshot = await get(emailQuery);
                  if (snapshot.exists()) {
                        const creatorKey = Object.keys(snapshot.val())[0];
                        await update(ref(db, `verified_creators/${creatorKey}`), {
                              onboardingStatus: 'completed',
                              updatedAt: new Date().toISOString()
                        });
                  }

                  // Navigate to dashboard
                  navigate('/dashboard/creator/home', {
                        state: { activeLink: 'creator' },
                        replace: true
                  });
            } catch (error) {
                  console.error('Error updating onboarding status:', error);
            }
      };

      // Show error if no account ID
      if (!stripeAccountId) {
            return (
                  <CCard className="p-4">
                        <CCardBody className="text-center text-danger">
                              <p>Error: No Stripe Account ID provided</p>
                        </CCardBody>
                  </CCard>
            );
      }

      // Show loading state
      if (!isReady) {
            return (
                  <CCard className="p-4">
                        <CCardBody className="text-center">
                              <CSpinner />
                              <p>Loading onboarding form... (Ready: {String(isReady)})</p>
                              <small className="mb-2">Account ID: {stripeAccountId}</small>
                              <br />
                              <small className="mb-2">Connect Components: {JSON.stringify(connectComponents)}</small>
                        </CCardBody>
                  </CCard>
            );
      }

      return (
            <CCard className="p-4">
                  <CCardBody>
                        <ConnectAccountOnboarding
                              accountId={stripeAccountId}
                              onExit={handleExit}
                              appearance={{
                                    theme: 'light',
                                    variables: {
                                          colorPrimary: '#0d6efd',
                                    },
                              }}
                              options={{
                                    locale: 'en',
                                    componentName: 'connectAccountOnboarding'
                              }}
                        />
                  </CCardBody>
            </CCard>
      );
};

export default Onboarding; 

